/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AmountInput from './AmountInput/index'
import AutoApplyToggle from './AutoApplyToggle/index'
import NotesInput from './NotesInput/index'
import PaymentMethodSelect from './PaymentMethodSelect/index'
import PaymentMethods from './PaymentMethods/index'
import React from 'react'
import ReceiptEmailCheckbox from './ReceiptEmailCheckbox/index'
import ReceiptEmailInput from './ReceiptEmailInput/index'
import ReceiptPrintCheckbox from './ReceiptPrintCheckbox/index'
import RefNumberInput from './RefNumberInput/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content"
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AmountInput
  viewPath={`${viewPath}/AmountInput`}
/>
<RefNumberInput
  viewPath={`${viewPath}/RefNumberInput`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<AutoApplyToggle
  viewPath={`${viewPath}/AutoApplyToggle`}
/>
</div>
<NotesInput
  viewPath={`${viewPath}/NotesInput`}
/>
<PaymentMethodSelect
  viewPath={`${viewPath}/PaymentMethodSelect`}
/>
<PaymentMethods
  viewPath={`${viewPath}/PaymentMethods`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Receipt"
 color={dtColorsNeutral900}
 size="normal"
 weight="medium"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ReceiptPrintCheckbox
  viewPath={`${viewPath}/ReceiptPrintCheckbox`}
/>
<ReceiptEmailCheckbox
  viewPath={`${viewPath}/ReceiptEmailCheckbox`}
/>
</div>
<ReceiptEmailInput
  viewPath={`${viewPath}/ReceiptEmailInput`}
/>
</div>
</div>
{children}
</React.Fragment>)
}